import React from "react";
import { STAFF } from "../../data/mockData";

export default function Staff() {
  return (
    <div className="panel">
      <div className="panel-hd">
        <span className="panel-hd-title">Staff Directory</span>
        <button className="btn-dark">+ Add Staff</button>
      </div>
      <div style={{ overflowX:"auto" }}>
        <table className="tbl">
          <thead>
            <tr><th>Name</th><th>Role</th><th>Shift</th><th>Status</th><th>Tasks Today</th><th>Action</th></tr>
          </thead>
          <tbody>
            {STAFF.map(s => (
              <tr key={s.id}>
                <td>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <div className="avatar" style={{ width:32, height:32, fontSize:15 }}>{s.name.charAt(0)}</div>
                    {s.name}
                  </div>
                </td>
                <td>{s.role}</td>
                <td><span className="badge badge-gray">{s.shift}</span></td>
                <td><span className={`badge ${s.status==="on-duty"?"badge-green":"badge-gray"}`}>{s.status}</span></td>
                <td>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <div className="prog-wrap" style={{ flex:1 }}>
                      <div className="prog-fill" style={{ width:`${(s.tasks/8)*100}%`, background:"#c8a05a" }}/>
                    </div>
                    <span style={{ fontSize:11, color:"#8a7060", flexShrink:0 }}>{s.tasks}/8</span>
                  </div>
                </td>
                <td>
                  <div style={{ display:"flex", gap:6 }}>
                    <button className="btn-outline" style={{ padding:"5px 10px", fontSize:10 }}>Edit</button>
                    <button className="btn-outline" style={{ padding:"5px 10px", fontSize:10 }}>Assign</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
